<script lang="ts" setup>
import NavigationMenuHome from '~/assets/icons/app/NavigationMenuHomeWhite.png'
import NavigationMenuGenerate from '~/assets/icons/app/NavigationMenuGenerateWhite.png'
import NavigationMenuLibrary from '~/assets/icons/app/NavigationMenuLibraryWhite.png'
import NavigationMenuStemSeparation from '~/assets/icons/app/NavigationMenuStemSeparationWhite.png'

interface BottomNavItem {
  label: string
  to: string
  icon: string
  activeIcon: string
  requireLogin?: boolean
}

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const loginStore = useLoginStore()

const items: BottomNavItem[] = [
  {
    label: 'Home',
    to: '/',
    icon: NavigationMenuHome,
    activeIcon: NavigationMenuHome
  },
  {
    label: 'Generate',
    to: '/generate',
    icon: NavigationMenuGenerate,
    activeIcon: NavigationMenuGenerate,
    requireLogin: true
  },
  // {
  //   label: 'Stems',
  //   to: '/stemSeparation',
  //   icon: NavigationMenuStemSeparation,
  //   activeIcon: NavigationMenuStemSeparation,
  //   requireLogin: true
  // },
  {
    label: 'Library',
    to: '/library/mySongs',
    icon: NavigationMenuLibrary,
    activeIcon: NavigationMenuLibrary,
    requireLogin: true
  }
]

const handleItemClick = (item: BottomNavItem) => {
  if (item.requireLogin && !authStore.isAuthenticated) {
    loginStore.openLoginModal('SignIn')
    return
  }

  if (route.path !== item.to) {
    router.push(item.to)
  }
}

const isActive = (item: BottomNavItem) => route.path === item.to
</script>

<template>
  <nav class="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#131318] border-t border-[#383847]">
    <div class="max-w-[768px] mx-auto flex items-center justify-around h-[60px] px-[16px]">
      <div
        v-for="item in items"
        :key="item.to"
        class="flex flex-col items-center justify-center w-[25%]"
      >
        <button
          :class="`rounded-full ${item.to === '/generate' && 'bg-[#BF2AFF] py-[8px] px-[26px]'} ${isActive(item) && 'bg-[#383847]! py-[2px] px-[14px]'}`"
          @click="handleItemClick(item)"
        >
          <img
            :src="isActive(item) ? item.activeIcon : item.icon"
            class="size-[24px]"
            alt=""
          >
        </button>
      </div>
    </div>
  </nav>
</template>
